var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container bg-white px-0 px-md-5 d-flex flex-column justify-content-center title-box pb-3"},[_vm._t("default"),_vm._v(" "),_c('a',{staticClass:"text-center",attrs:{"href":_vm.pageLink}},[_c('i',{staticClass:"fas fa-caret-down fa-3x text-success"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }